var q = Object.prototype.hasOwnProperty;
function I(e, n) {
  var t, o;
  if (e === n) return !0;
  if (e && n && (t = e.constructor) === n.constructor) {
    if (t === Date) return e.getTime() === n.getTime();
    if (t === RegExp) return e.toString() === n.toString();
    if (t === Array) {
      if ((o = e.length) === n.length)
        for (; o-- && I(e[o], n[o]); ) ;
      return o === -1;
    }
    if (!t || typeof e == "object") {
      o = 0;
      for (t in e)
        if (q.call(e, t) && ++o && !q.call(n, t) || !(t in n) || !I(e[t], n[t])) return !1;
      return Object.keys(n).length === o;
    }
  }
  return e !== e && n !== n;
}
function _() {
}
function Z(e, n) {
  return e != e ? n == n : e !== n || e && typeof e == "object" || typeof e == "function";
}
const x = [];
function M(e, n = _) {
  let t;
  const o = /* @__PURE__ */ new Set();
  function d(v) {
    if (Z(e, v) && (e = v, t)) {
      const w = !x.length;
      for (const g of o)
        g[1](), x.push(g, e);
      if (w) {
        for (let g = 0; g < x.length; g += 2)
          x[g][0](x[g + 1]);
        x.length = 0;
      }
    }
  }
  function p(v) {
    d(v(e));
  }
  function m(v, w = _) {
    const g = [v, w];
    return o.add(g), o.size === 1 && (t = n(d, p) || _), v(e), () => {
      o.delete(g), o.size === 0 && t && (t(), t = null);
    };
  }
  return { set: d, update: p, subscribe: m };
}
const Ue = (e) => {
  const { subscribe: n, set: t } = M();
  let o;
  return n((d) => o = d), e.observe(({ changes: d }) => {
    if (o) {
      (d.deleted || []).some((v) => v.id === o) && t(void 0);
      const m = (d.updated || []).find(({ oldValue: v }) => v.id === o);
      m && t(m.newValue.id);
    }
  }), {
    get current() {
      return o;
    },
    subscribe: n,
    set: t
  };
};
var F = /* @__PURE__ */ ((e) => (e.EDIT = "EDIT", e.SELECT = "SELECT", e.NONE = "NONE", e))(F || {});
const z = { selected: [] }, Te = (e, n, t) => {
  const { subscribe: o, set: d } = M(z);
  let p = n, m = z;
  o((h) => m = h);
  const v = () => {
    I(m, z) || d(z);
  }, w = () => {
    var h;
    return ((h = m.selected) == null ? void 0 : h.length) === 0;
  }, g = (h) => {
    if (w())
      return !1;
    const C = typeof h == "string" ? h : h.id;
    return m.selected.some((O) => O.id === C);
  }, L = (h, C) => {
    const O = e.getAnnotation(h);
    if (!O) {
      console.warn("Invalid selection: " + h);
      return;
    }
    switch (G(O, p, t)) {
      case "EDIT":
        d({ selected: [{ id: h, editable: !0 }], event: C });
        break;
      case "SELECT":
        d({ selected: [{ id: h }], event: C });
        break;
      default:
        d({ selected: [], event: C });
    }
  }, a = (h, C) => {
    const O = Array.isArray(h) ? h : [h], r = O.map((u) => e.getAnnotation(u)).filter((u) => !!u);
    d({
      selected: r.map((u) => {
        const s = C === void 0 ? G(u, p, t) === "EDIT" : C;
        return { id: u.id, editable: s };
      })
    }), r.length !== O.length && console.warn("Invalid selection", h);
  }, E = (h) => {
    if (w())
      return !1;
    const { selected: C } = m;
    C.some(({ id: r }) => h.includes(r)) && d({ selected: C.filter(({ id: r }) => !h.includes(r)) });
  }, U = (h) => p = h;
  return e.observe(
    ({ changes: h }) => E((h.deleted || []).map((C) => C.id))
  ), {
    get event() {
      return m ? m.event : null;
    },
    get selected() {
      return m ? [...m.selected] : null;
    },
    get userSelectAction() {
      return p;
    },
    clear: v,
    isEmpty: w,
    isSelected: g,
    setSelected: a,
    setUserSelectAction: U,
    subscribe: o,
    userSelect: L
  };
}, G = (e, n, t) => {
  const o = t ? t.serialize(e) : e;
  return typeof n == "function" ? n(o) : n || "EDIT";
};
var D = [];
for (var Y = 0; Y < 256; ++Y)
  D.push((Y + 256).toString(16).slice(1));
function K(e, n = 0) {
  return (D[e[n + 0]] + D[e[n + 1]] + D[e[n + 2]] + D[e[n + 3]] + "-" + D[e[n + 4]] + D[e[n + 5]] + "-" + D[e[n + 6]] + D[e[n + 7]] + "-" + D[e[n + 8]] + D[e[n + 9]] + "-" + D[e[n + 10]] + D[e[n + 11]] + D[e[n + 12]] + D[e[n + 13]] + D[e[n + 14]] + D[e[n + 15]]).toLowerCase();
}
var $, ee = new Uint8Array(16);
function te() {
  if (!$ && ($ = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !$))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return $(ee);
}
var ne = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const H = {
  randomUUID: ne
};
function J(e, n, t) {
  if (H.randomUUID && !n && !e)
    return H.randomUUID();
  e = e || {};
  var o = e.random || (e.rng || te)();
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, K(o);
}
const Oe = (e) => {
  const { creator: n, updatedBy: t } = e.target, o = e.bodies.reduce((d, p) => [...d, p.creator, p.updatedBy].filter(Boolean), []);
  return [
    n,
    t,
    ...o
  ].filter((d) => d);
}, j = (e) => {
  const n = (t) => {
    const o = { ...t };
    return t.created && typeof t.created == "string" && (o.created = new Date(t.created)), t.updated && typeof t.updated == "string" && (o.updated = new Date(t.updated)), o;
  };
  return {
    ...e,
    bodies: (e.bodies || []).map(n),
    target: n(e.target)
  };
}, De = (e, n, t, o) => ({
  id: J(),
  annotation: typeof e == "string" ? e : e.id,
  created: t || /* @__PURE__ */ new Date(),
  creator: o,
  ...n
}), oe = (e, n) => {
  const t = new Set(e.bodies.map((o) => o.id));
  return n.bodies.filter((o) => !t.has(o.id));
}, se = (e, n) => {
  const t = new Set(n.bodies.map((o) => o.id));
  return e.bodies.filter((o) => !t.has(o.id));
}, ie = (e, n) => n.bodies.map((t) => {
  const o = e.bodies.find((d) => d.id === t.id);
  return { newBody: t, oldBody: o && !I(o, t) ? o : void 0 };
}).filter(({ oldBody: t }) => t).map(({ oldBody: t, newBody: o }) => ({ oldBody: t, newBody: o })), de = (e, n) => !I(e.target, n.target), Q = (e, n) => {
  const t = oe(e, n), o = se(e, n), d = ie(e, n);
  return {
    oldValue: e,
    newValue: n,
    bodiesCreated: t.length > 0 ? t : void 0,
    bodiesDeleted: o.length > 0 ? o : void 0,
    bodiesUpdated: d.length > 0 ? d : void 0,
    targetUpdated: de(e, n) ? { oldTarget: e.target, newTarget: n.target } : void 0
  };
};
var re = /* @__PURE__ */ ((e) => (e.BODY_ONLY = "BODY_ONLY", e.TARGET_ONLY = "TARGET_ONLY", e))(re || {}), T = /* @__PURE__ */ ((e) => (e.LOCAL = "LOCAL", e.REMOTE = "REMOTE", e.SILENT = "SILENT", e))(T || {});
const ae = (e, n) => {
  var p, m;
  const { changes: t, origin: o } = n;
  if (!(e.options.origin ? e.options.origin === o : o !== "SILENT"))
    return !1;
  if (e.options.ignore) {
    const { ignore: v } = e.options, w = (L) => L && L.length > 0;
    if (!(w(t.created) || w(t.deleted))) {
      const L = (p = t.updated) == null ? void 0 : p.some((E) => w(E.bodiesCreated) || w(E.bodiesDeleted) || w(E.bodiesUpdated)), a = (m = t.updated) == null ? void 0 : m.some((E) => E.targetUpdated);
      if (v === "BODY_ONLY" && L && !a || v === "TARGET_ONLY" && a && !L)
        return !1;
    }
  }
  if (e.options.annotations) {
    const v = /* @__PURE__ */ new Set([
      ...(t.created || []).map((g) => g.id),
      ...(t.deleted || []).map((g) => g.id),
      ...(t.updated || []).map(({ oldValue: g }) => g.id)
    ]);
    return !!(Array.isArray(e.options.annotations) ? e.options.annotations : [e.options.annotations]).find((g) => v.has(g));
  } else
    return !0;
}, ce = (e, n) => {
  const t = new Set((e.created || []).map((a) => a.id)), o = new Set((e.updated || []).map(({ newValue: a }) => a.id)), d = new Set((n.created || []).map((a) => a.id)), p = new Set((n.deleted || []).map((a) => a.id)), m = new Set((n.updated || []).map(({ oldValue: a }) => a.id)), v = new Set((n.updated || []).filter(({ oldValue: a }) => t.has(a.id) || o.has(a.id)).map(({ oldValue: a }) => a.id)), w = [
    ...(e.created || []).filter((a) => !p.has(a.id)).map((a) => m.has(a.id) ? n.updated.find(({ oldValue: E }) => E.id === a.id).newValue : a),
    ...n.created || []
  ], g = [
    ...(e.deleted || []).filter((a) => !d.has(a.id)),
    ...(n.deleted || []).filter((a) => !t.has(a.id))
  ], L = [
    ...(e.updated || []).filter(({ newValue: a }) => !p.has(a.id)).map((a) => {
      const { oldValue: E, newValue: U } = a;
      if (m.has(U.id)) {
        const h = n.updated.find((C) => C.oldValue.id === U.id).newValue;
        return Q(E, h);
      } else
        return a;
    }),
    ...(n.updated || []).filter(({ oldValue: a }) => !v.has(a.id))
  ];
  return { created: w, deleted: g, updated: L };
}, V = (e) => {
  const n = e.id === void 0 ? J() : e.id;
  return {
    ...e,
    id: n,
    bodies: e.bodies === void 0 ? [] : e.bodies.map((t) => ({
      ...t,
      annotation: n
    })),
    target: {
      ...e.target,
      annotation: n
    }
  };
}, le = (e) => e.id !== void 0, Re = () => {
  const e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), t = [], o = (i, c = {}) => {
    t.push({ onChange: i, options: c });
  }, d = (i) => {
    const c = t.findIndex((l) => l.onChange == i);
    c > -1 && t.splice(c, 1);
  }, p = (i, c) => {
    const l = {
      origin: i,
      changes: {
        created: c.created || [],
        updated: c.updated || [],
        deleted: c.deleted || []
      },
      state: [...e.values()]
    };
    t.forEach((f) => {
      ae(f, l) && f.onChange(l);
    });
  }, m = (i, c = T.LOCAL) => {
    if (i.id && e.get(i.id))
      throw Error(`Cannot add annotation ${i.id} - exists already`);
    {
      const f = V(i);
      e.set(f.id, f), f.bodies.forEach((S) => n.set(S.id, f.id)), p(c, { created: [f] });
    }
  }, v = (i, c) => {
    const l = V(typeof i == "string" ? c : i), f = typeof i == "string" ? i : i.id, S = f && e.get(f);
    if (S) {
      const y = Q(S, l);
      return f === l.id ? e.set(f, l) : (e.delete(f), e.set(l.id, l)), S.bodies.forEach((B) => n.delete(B.id)), l.bodies.forEach((B) => n.set(B.id, l.id)), y;
    } else
      console.warn(`Cannot update annotation ${f} - does not exist`);
  }, w = (i, c = T.LOCAL, l = T.LOCAL) => {
    const f = le(c) ? l : c, S = v(i, c);
    S && p(f, { updated: [S] });
  }, g = (i, c = T.LOCAL) => {
    const l = i.reduce((f, S) => {
      const y = v(S);
      return y ? [...f, y] : f;
    }, []);
    l.length > 0 && p(c, { updated: l });
  }, L = (i, c = T.LOCAL) => {
    const l = e.get(i.annotation);
    if (l) {
      const f = {
        ...l,
        bodies: [...l.bodies, i]
      };
      e.set(l.id, f), n.set(i.id, f.id), p(c, { updated: [{
        oldValue: l,
        newValue: f,
        bodiesCreated: [i]
      }] });
    } else
      console.warn(`Attempt to add body to missing annotation: ${i.annotation}`);
  }, a = () => [...e.values()], E = (i = T.LOCAL) => {
    const c = [...e.values()];
    e.clear(), n.clear(), p(i, { deleted: c });
  }, U = (i, c = !0, l = T.LOCAL) => {
    const f = i.map(V);
    if (c) {
      const S = [...e.values()];
      e.clear(), n.clear(), f.forEach((y) => {
        e.set(y.id, y), y.bodies.forEach((B) => n.set(B.id, y.id));
      }), p(l, { created: f, deleted: S });
    } else {
      const S = i.reduce((y, B) => {
        const W = B.id && e.get(B.id);
        return W ? [...y, W] : y;
      }, []);
      if (S.length > 0)
        throw Error(`Bulk insert would overwrite the following annotations: ${S.map((y) => y.id).join(", ")}`);
      f.forEach((y) => {
        e.set(y.id, y), y.bodies.forEach((B) => n.set(B.id, y.id));
      }), p(l, { created: f });
    }
  }, h = (i) => {
    const c = typeof i == "string" ? i : i.id, l = e.get(c);
    if (l)
      return e.delete(c), l.bodies.forEach((f) => n.delete(f.id)), l;
    console.warn(`Attempt to delete missing annotation: ${c}`);
  }, C = (i, c = T.LOCAL) => {
    const l = h(i);
    l && p(c, { deleted: [l] });
  }, O = (i, c = T.LOCAL) => {
    const l = i.reduce((f, S) => {
      const y = h(S);
      return y ? [...f, y] : f;
    }, []);
    l.length > 0 && p(c, { deleted: l });
  }, r = (i) => {
    const c = e.get(i.annotation);
    if (c) {
      const l = c.bodies.find((f) => f.id === i.id);
      if (l) {
        n.delete(l.id);
        const f = {
          ...c,
          bodies: c.bodies.filter((y) => y.id !== i.id)
        };
        return e.set(c.id, f), {
          oldValue: c,
          newValue: f,
          bodiesDeleted: [l]
        };
      } else
        console.warn(`Attempt to delete missing body ${i.id} from annotation ${i.annotation}`);
    } else
      console.warn(`Attempt to delete body from missing annotation ${i.annotation}`);
  }, u = (i, c = T.LOCAL) => {
    const l = r(i);
    l && p(c, { updated: [l] });
  }, s = (i, c = T.LOCAL) => {
    const l = i.map((f) => r(f)).filter(Boolean);
    l.length > 0 && p(c, { updated: l });
  }, A = (i) => {
    const c = e.get(i);
    return c ? { ...c } : void 0;
  }, b = (i) => {
    const c = n.get(i);
    if (c) {
      const f = A(c).bodies.find((S) => S.id === i);
      if (f)
        return f;
      console.error(`Store integrity error: body ${i} in index, but not in annotation`);
    } else
      console.warn(`Attempt to retrieve missing body: ${i}`);
  }, R = (i, c) => {
    if (i.annotation !== c.annotation)
      throw "Annotation integrity violation: annotation ID must be the same when updating bodies";
    const l = e.get(i.annotation);
    if (l) {
      const f = l.bodies.find((y) => y.id === i.id), S = {
        ...l,
        bodies: l.bodies.map((y) => y.id === f.id ? c : y)
      };
      return e.set(l.id, S), f.id !== c.id && (n.delete(f.id), n.set(c.id, S.id)), {
        oldValue: l,
        newValue: S,
        bodiesUpdated: [{ oldBody: f, newBody: c }]
      };
    } else
      console.warn(`Attempt to add body to missing annotation ${i.annotation}`);
  }, N = (i, c, l = T.LOCAL) => {
    const f = R(i, c);
    f && p(l, { updated: [f] });
  }, k = (i, c = T.LOCAL) => {
    const l = i.map((f) => R({ id: f.id, annotation: f.annotation }, f)).filter(Boolean);
    p(c, { updated: l });
  }, P = (i) => {
    const c = e.get(i.annotation);
    if (c) {
      const l = {
        ...c,
        target: {
          ...c.target,
          ...i
        }
      };
      return e.set(c.id, l), {
        oldValue: c,
        newValue: l,
        targetUpdated: {
          oldTarget: c.target,
          newTarget: i
        }
      };
    } else
      console.warn(`Attempt to update target on missing annotation: ${i.annotation}`);
  };
  return {
    addAnnotation: m,
    addBody: L,
    all: a,
    bulkAddAnnotation: U,
    bulkDeleteAnnotation: O,
    bulkDeleteBodies: s,
    bulkUpdateAnnotation: g,
    bulkUpdateBodies: k,
    bulkUpdateTargets: (i, c = T.LOCAL) => {
      const l = i.map((f) => P(f)).filter(Boolean);
      l.length > 0 && p(c, { updated: l });
    },
    clear: E,
    deleteAnnotation: C,
    deleteBody: u,
    getAnnotation: A,
    getBody: b,
    observe: o,
    unobserve: d,
    updateAnnotation: w,
    updateBody: N,
    updateTarget: (i, c = T.LOCAL) => {
      const l = P(i);
      l && p(c, { updated: [l] });
    }
  };
}, Be = (e) => ({
  ...e,
  subscribe: (t) => {
    const o = (d) => t(d.state);
    return e.observe(o), t(e.all()), () => e.unobserve(o);
  }
});
let X = () => ({
  emit(e, ...n) {
    for (let t = 0, o = this.events[e] || [], d = o.length; t < d; t++)
      o[t](...n);
  },
  events: {},
  on(e, n) {
    var t;
    return ((t = this.events)[e] || (t[e] = [])).push(n), () => {
      var o;
      this.events[e] = (o = this.events[e]) == null ? void 0 : o.filter((d) => n !== d);
    };
  }
});
const ue = 250, Ie = (e) => {
  const n = X(), t = [];
  let o = -1, d = !1, p = 0;
  const m = (s) => {
    if (!d) {
      const { changes: A } = s, b = performance.now();
      if (b - p > ue)
        t.splice(o + 1), t.push(A), o = t.length - 1;
      else {
        const R = t.length - 1;
        t[R] = ce(t[R], A);
      }
      p = b;
    }
    d = !1;
  };
  e.observe(m, { origin: T.LOCAL });
  const v = (s) => s && s.length > 0 && e.bulkDeleteAnnotation(s), w = (s) => s && s.length > 0 && e.bulkAddAnnotation(s, !1), g = (s) => s && s.length > 0 && e.bulkUpdateAnnotation(s.map(({ oldValue: A }) => A)), L = (s) => s && s.length > 0 && e.bulkUpdateAnnotation(s.map(({ newValue: A }) => A)), a = (s) => s && s.length > 0 && e.bulkAddAnnotation(s, !1), E = (s) => s && s.length > 0 && e.bulkDeleteAnnotation(s);
  return {
    canRedo: () => t.length - 1 > o,
    canUndo: () => o > -1,
    destroy: () => e.unobserve(m),
    on: (s, A) => n.on(s, A),
    redo: () => {
      if (t.length - 1 > o) {
        d = !0;
        const { created: s, updated: A, deleted: b } = t[o + 1];
        w(s), L(A), E(b), n.emit("redo", t[o + 1]), o += 1;
      }
    },
    undo: () => {
      if (o > -1) {
        d = !0;
        const { created: s, updated: A, deleted: b } = t[o];
        v(s), g(A), a(b), n.emit("undo", t[o]), o -= 1;
      }
    }
  };
}, ke = () => {
  const { subscribe: e, set: n } = M([]);
  return {
    subscribe: e,
    set: n
  };
}, xe = (e, n, t, o) => {
  const { hover: d, selection: p, store: m, viewport: v } = e, w = /* @__PURE__ */ new Map();
  let g = [], L, a;
  const E = (r, u) => {
    w.has(r) ? w.get(r).push(u) : w.set(r, [u]);
  }, U = (r, u) => {
    const s = w.get(r);
    if (s) {
      const A = s.indexOf(u);
      A !== -1 && s.splice(A, 1);
    }
  }, h = (r, u, s) => {
    w.has(r) && setTimeout(() => {
      w.get(r).forEach((A) => {
        if (t) {
          const b = Array.isArray(u) ? u.map((N) => t.serialize(N)) : t.serialize(u), R = s ? s instanceof PointerEvent ? s : t.serialize(s) : void 0;
          A(b, R);
        } else
          A(u, s);
      });
    }, 1);
  }, C = () => {
    const { selected: r } = p, u = (r || []).map(({ id: s }) => m.getAnnotation(s));
    u.forEach((s) => {
      const A = g.find((b) => b.id === s.id);
      (!A || !I(A, s)) && h("updateAnnotation", s, A);
    }), g = g.map((s) => {
      const A = u.find(({ id: b }) => b === s.id);
      return A || s;
    });
  };
  p.subscribe(({ selected: r }) => {
    if (!(g.length === 0 && r.length === 0)) {
      if (g.length === 0 && r.length > 0)
        g = r.map(({ id: u }) => m.getAnnotation(u));
      else if (g.length > 0 && r.length === 0)
        g.forEach((u) => {
          const s = m.getAnnotation(u.id);
          s && !I(s, u) && h("updateAnnotation", s, u);
        }), g = [];
      else {
        const u = new Set(g.map((b) => b.id)), s = new Set(r.map(({ id: b }) => b));
        g.filter((b) => !s.has(b.id)).forEach((b) => {
          const R = m.getAnnotation(b.id);
          R && !I(R, b) && h("updateAnnotation", R, b);
        }), g = [
          // Remove annotations that were deselected
          ...g.filter((b) => s.has(b.id)),
          // Add editable annotations that were selected
          ...r.filter(({ id: b }) => !u.has(b)).map(({ id: b }) => m.getAnnotation(b))
        ];
      }
      h("selectionChanged", g);
    }
  }), d.subscribe((r) => {
    !L && r ? h("mouseEnterAnnotation", m.getAnnotation(r)) : L && !r ? h("mouseLeaveAnnotation", m.getAnnotation(L)) : L && r && (h("mouseLeaveAnnotation", m.getAnnotation(L)), h("mouseEnterAnnotation", m.getAnnotation(r))), L = r;
  }), v == null || v.subscribe((r) => h("viewportIntersect", r.map((u) => m.getAnnotation(u)))), m.observe((r) => {
    o && (a && clearTimeout(a), a = setTimeout(C, 1e3));
    const { created: u, deleted: s } = r.changes;
    (u || []).forEach((b) => h("createAnnotation", b)), (s || []).forEach((b) => h("deleteAnnotation", b)), (r.changes.updated || []).filter((b) => [
      ...b.bodiesCreated || [],
      ...b.bodiesDeleted || [],
      ...b.bodiesUpdated || []
    ].length > 0).forEach(({ oldValue: b, newValue: R }) => {
      const N = g.find((k) => k.id === b.id) || b;
      g = g.map((k) => k.id === b.id ? R : k), h("updateAnnotation", R, N);
    });
  }, { origin: T.LOCAL }), m.observe((r) => {
    if (g) {
      const u = new Set(g.map((A) => A.id)), s = (r.changes.updated || []).filter(({ newValue: A }) => u.has(A.id)).map(({ newValue: A }) => A);
      s.length > 0 && (g = g.map((A) => {
        const b = s.find((R) => R.id === A.id);
        return b || A;
      }));
    }
  }, { origin: T.REMOTE });
  const O = (r) => (u) => {
    const { updated: s } = u;
    r ? (s || []).forEach((A) => h("updateAnnotation", A.oldValue, A.newValue)) : (s || []).forEach((A) => h("updateAnnotation", A.newValue, A.oldValue));
  };
  return n.on("undo", O(!0)), n.on("redo", O(!1)), { on: E, off: U, emit: h };
}, Ne = (e) => (n) => n.map((t) => e.serialize(t)), fe = (e) => (n) => n.reduce((t, o) => {
  const { parsed: d, error: p } = e.parse(o);
  return p ? {
    parsed: t.parsed,
    failed: [...t.failed, o]
  } : d ? {
    parsed: [...t.parsed, d],
    failed: t.failed
  } : {
    ...t
  };
}, { parsed: [], failed: [] }), ze = (e, n, t) => {
  const { store: o, selection: d } = e, p = (r) => {
    if (t) {
      const { parsed: u, error: s } = t.parse(r);
      u ? o.addAnnotation(u, T.REMOTE) : console.error(s);
    } else
      o.addAnnotation(j(r), T.REMOTE);
  }, m = () => d.clear(), v = () => o.clear(), w = (r) => {
    const u = o.getAnnotation(r);
    return t && u ? t.serialize(u) : u;
  }, g = () => t ? o.all().map(t.serialize) : o.all(), L = () => {
    var s;
    const u = (((s = d.selected) == null ? void 0 : s.map((A) => A.id)) || []).map((A) => o.getAnnotation(A)).filter(Boolean);
    return t ? u.map(t.serialize) : u;
  }, a = (r, u = !0) => fetch(r).then((s) => s.json()).then((s) => (U(s, u), s)), E = (r) => {
    if (typeof r == "string") {
      const u = o.getAnnotation(r);
      if (o.deleteAnnotation(r), u)
        return t ? t.serialize(u) : u;
    } else {
      const u = t ? t.parse(r).parsed : r;
      if (u)
        return o.deleteAnnotation(u), r;
    }
  }, U = (r, u = !0) => {
    if (t) {
      const s = t.parseAll || fe(t), { parsed: A, failed: b } = s(r);
      b.length > 0 && console.warn(`Discarded ${b.length} invalid annotations`, b), o.bulkAddAnnotation(A, u, T.REMOTE);
    } else
      o.bulkAddAnnotation(r.map(j), u, T.REMOTE);
  }, h = (r, u) => {
    r ? d.setSelected(r, u) : d.clear();
  }, C = (r) => {
    d.clear(), d.setUserSelectAction(r);
  }, O = (r) => {
    if (t) {
      const u = t.parse(r).parsed, s = t.serialize(o.getAnnotation(u.id));
      return o.updateAnnotation(u), s;
    } else {
      const u = o.getAnnotation(r.id);
      return o.updateAnnotation(j(r)), u;
    }
  };
  return {
    addAnnotation: p,
    cancelSelected: m,
    canRedo: n.canRedo,
    canUndo: n.canUndo,
    clearAnnotations: v,
    getAnnotationById: w,
    getAnnotations: g,
    getSelected: L,
    loadAnnotations: a,
    redo: n.redo,
    removeAnnotation: E,
    setAnnotations: U,
    setSelected: h,
    setUserSelectAction: C,
    undo: n.undo,
    updateAnnotation: O
  };
}, $e = (e, n, t) => typeof n == "function" ? n(e, t) : n, Ve = (e, n) => typeof e != "function" && typeof n != "function" ? {
  ...e || {},
  ...n || {}
} : (t, o) => {
  const d = typeof e == "function" ? e(t, o) : e, p = typeof n == "function" ? n(t, o) : n;
  return {
    ...d || {},
    ...p || {}
  };
}, pe = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let ge = (e) => crypto.getRandomValues(new Uint8Array(e)), he = (e, n, t) => {
  let o = (2 << Math.log(e.length - 1) / Math.LN2) - 1, d = -~(1.6 * o * n / e.length);
  return (p = n) => {
    let m = "";
    for (; ; ) {
      let v = t(d), w = d;
      for (; w--; )
        if (m += e[v[w] & o] || "", m.length === p) return m;
    }
  };
}, me = (e, n = 21) => he(e, n, ge), Ae = (e = 21) => {
  let n = "", t = crypto.getRandomValues(new Uint8Array(e));
  for (; e--; )
    n += pe[t[e] & 63];
  return n;
};
const _e = () => ({ isGuest: !0, id: me("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_", 20)() }), be = (e) => {
  const n = JSON.stringify(e);
  let t = 0;
  for (let o = 0, d = n.length; o < d; o++) {
    let p = n.charCodeAt(o);
    t = (t << 5) - t + p, t |= 0;
  }
  return `${t}`;
}, ve = (e) => e ? typeof e == "object" ? { ...e } : e : void 0, Ye = (e, n) => (Array.isArray(e) ? e : [e]).map((t) => {
  const { id: o, type: d, purpose: p, value: m, created: v, modified: w, creator: g, ...L } = t;
  return {
    id: o || `temp-${be(t)}`,
    annotation: n,
    type: d,
    purpose: p,
    value: m,
    creator: ve(g),
    created: v ? new Date(v) : void 0,
    updated: w ? new Date(w) : void 0,
    ...L
  };
}), je = (e) => e.map((n) => {
  var v;
  const { annotation: t, created: o, updated: d, ...p } = n, m = {
    ...p,
    created: o == null ? void 0 : o.toISOString(),
    modified: d == null ? void 0 : d.toISOString()
  };
  return (v = m.id) != null && v.startsWith("temp-") && delete m.id, m;
}), Ee = [
  "#ff7c00",
  // orange
  "#1ac938",
  // green
  "#e8000b",
  // red
  "#8b2be2",
  // purple
  "#9f4800",
  // brown
  "#f14cc1",
  // pink
  "#ffc400",
  // khaki
  "#00d7ff",
  // cyan
  "#023eff"
  // blue
], we = () => {
  const e = [...Ee];
  return { assignRandomColor: () => {
    const o = Math.floor(Math.random() * e.length), d = e[o];
    return e.splice(o, 1), d;
  }, releaseColor: (o) => e.push(o) };
}, Ce = () => {
  const e = we();
  return { addUser: (o, d) => {
    const p = e.assignRandomColor();
    return {
      label: d.name || d.id,
      avatar: d.avatar,
      color: p
    };
  }, removeUser: (o) => e.releaseColor(o.appearance.color) };
}, ye = (e, n) => e.every((t) => e.includes(t)) && n.every((t) => e.includes(t)), Me = Ae(), Pe = (e = Ce()) => {
  const n = X(), t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), d = (a, E) => {
    if (t.has(a)) {
      console.warn("Attempt to add user that is already present", a, E);
      return;
    }
    const U = e.addUser(a, E);
    t.set(a, {
      ...E,
      presenceKey: a,
      appearance: U
    });
  }, p = (a) => {
    const E = t.get(a);
    if (!E) {
      console.warn("Attempt to remove user that is not present", a);
      return;
    }
    e.removeUser(E), t.delete(a);
  }, m = (a) => {
    const E = new Set(a.map((C) => C.presenceKey)), U = a.filter(({ presenceKey: C }) => !t.has(C)), h = Array.from(t.values()).filter((C) => !E.has(C.presenceKey));
    U.forEach(({ presenceKey: C, user: O }) => d(C, O)), h.forEach((C) => {
      const { presenceKey: O } = C;
      o.has(O) && n.emit("selectionChange", C, null), p(O);
    }), (U.length > 0 || h.length > 0) && n.emit("presence", g());
  }, v = (a, E) => {
    const U = t.get(a);
    if (!U) {
      console.warn("Activity notification from user that is not present");
      return;
    }
    const h = o.get(a);
    (!h || !ye(h, E)) && (o.set(a, E), n.emit("selectionChange", U, E));
  }, w = (a, E) => {
    const U = t.get(a);
    if (!U) {
      console.warn("Selection change for user that is not present", a);
      return;
    }
    E ? o.set(a, E) : o.delete(a), n.emit("selectionChange", U, E);
  }, g = () => [...Array.from(t.values())];
  return {
    getPresentUsers: g,
    notifyActivity: v,
    on: (a, E) => n.on(a, E),
    syncUsers: m,
    updateSelection: w
  };
};
export {
  re as Ignore,
  T as Origin,
  Me as PRESENCE_KEY,
  F as UserSelectAction,
  Ve as chainStyles,
  $e as computeStyle,
  _e as createAnonymousGuest,
  ze as createBaseAnnotator,
  De as createBody,
  Ce as createDefaultAppearanceProvider,
  Ue as createHoverState,
  xe as createLifecycleObserver,
  Pe as createPresenceState,
  Te as createSelectionState,
  Re as createStore,
  Ie as createUndoStack,
  ke as createViewportState,
  we as defaultColorProvider,
  Q as diffAnnotations,
  Oe as getContributors,
  ce as mergeChanges,
  G as onUserSelect,
  fe as parseAll,
  Ye as parseW3CBodies,
  ve as parseW3CUser,
  j as reviveDates,
  Ne as serializeAll,
  je as serializeW3CBodies,
  ae as shouldNotify,
  Be as toSvelteStore
};
//# sourceMappingURL=annotorious-core.es.js.map
